<template>
    <!-- 客户地址信息 -->
    <div>
        <el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" append-to-body top="2rem" width="80%" center :before-close="initActionBox">
            <el-form :model="sendDataInfo" v-if="formData" label-width="120px" size="mini" ref="sendDataInfo" :show-message="false">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="省市区">
                            <label slot="label" :style="$common.labelStyle('省市区')" v-html="'省市区'"></label>
                            <el-cascader ref="cascader" :props="{ emitPath: false, value: 'value', label: 'label', children: 'children' }" style="width: 100%;" :options="options" v-model="sendDataInfo.areaCode"
                                         @change="handleChange">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="formOneValue.entityField == 'caiAddress' || formOneValue.entityField == 'caiState' ? 24 : 12" v-for="(formOneValue, formOneKey) in formData.jurconfigform" :key="formOneKey">
                        <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                      :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                            <!-- 系统字段 -->
                            <div v-if="formOneValue.isReserved == 0">
                                <el-input v-if="formOneValue.entityField == 'caiAddress'" type="textarea" placeholder="请输入内容" v-model="sendDataInfo[formOneValue.entityField]" maxlength="64" show-word-limit
                                          clearable></el-input>
                                <el-radio-group v-else-if="formOneValue.entityField == 'caiState'" v-model="sendDataInfo[formOneValue.entityField]">
                                    <el-radio-button :label="0">禁用</el-radio-button>
                                    <el-radio-button :label="1">启用</el-radio-button>
                                </el-radio-group>
                                <el-select v-else-if="formOneValue.entityField == 'caiCountry'" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;" clearable>
                                    <el-option v-for="(values, keys) in countryList" :key="keys" :label="values.diName" :value="values.diValue">
                                    </el-option>
                                </el-select>

                                <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" clearable></el-input>

                            </div>
                            <!-- 扩展字段 -->
                            <div v-if="formOneValue.isReserved == 1">

                                <!-- 自填 -->
                                <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0" :maxlength="$store.state.inputLength" clearable></el-input>
                                <!-- 选择数据来源 -->
                                <el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-else :maxlength="$store.state.inputLength" clearable></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="initActionBox">取 消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { regionData} from 'element-china-area-data'
export default {
    name: 'customerAddress',
    // props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            options: regionData,
            selectedOptions: [],
            sendDataInfo: {
                "caiAddress": "",
                "caiArea": "",
                "caiCity": "",
                "caiCountry": "",
                "caiCreater": 0,
                "caiLinker": "",
                "caiPostcode": "",
                "caiProvince": "",
                "caiReserves1": "",
                "caiReserves2": "",
                "caiReserves3": "",
                "caiReserves4": "",
                "caiReserves5": "",
                "caiReserves6": "",
                "caiState": 0,
                "caiTelnumber": "",
                "cmId": 0,
                remark: '',
                isDefault: 0,
                areaCode: '',
            },
            formData: {
                "jciId": 11683,
                "jurId": "1609378973848",
                "jciName": "销售出库客户地址表单",
                "jciType": 3,
                "isForm": 1,
                "isShowForm": 0,
                "jurconfigtable": null,
                "jurconfigform": [
                    {
                        "jcfId": 5600,
                        "jciId": 11683,
                        "entityField": "caiId",
                        "chineseField": "客户收货地址id",
                        "showField": "客户收货地址id",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 0,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5603,
                        "jciId": 11683,
                        "entityField": "cmId",
                        "chineseField": "供货商id",
                        "showField": "供货商id",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 0,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5614,
                        "jciId": 11683,
                        "entityField": "cmModifier",
                        "chineseField": "修改人信息",
                        "showField": "修改人信息",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 0,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5615,
                        "jciId": 11683,
                        "entityField": "caiCreater",
                        "chineseField": "创建人",
                        "showField": "创建人",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 0,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    // {
                    // "jcfId": 5605,
                    // "jciId": 11683,
                    // "entityField": "caiProvince",
                    // "chineseField": "省",
                    // "showField": "省",
                    // "isShow": 1,
                    // "isRequired": 0,
                    // "isChange": 1,
                    // "fieldType": "string",
                    // "formatterContent": null,
                    // "searchId": null,
                    // "extractId": null,
                    // "isReserved": 0,
                    // "sort": 1,
                    // "fieldWeight": 100,
                    // "isRift": 0,
                    // "riftField": null
                    // },
                    // {
                    // "jcfId": 5598,
                    // "jciId": 11683,
                    // "entityField": "caiCity",
                    // "chineseField": "市",
                    // "showField": "市",
                    // "isShow": 1,
                    // "isRequired": 0,
                    // "isChange": 1,
                    // "fieldType": "string",
                    // "formatterContent": null,
                    // "searchId": null,
                    // "extractId": null,
                    // "isReserved": 0,
                    // "sort": 2,
                    // "fieldWeight": 100,
                    // "isRift": 0,
                    // "riftField": null
                    // },
                    {
                        "jcfId": 5602,
                        "jciId": 11683,
                        "entityField": "caiAddress",
                        "chineseField": "地址",
                        "showField": "地址",
                        "isShow": 1,
                        "isRequired": 1,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 3,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5601,
                        "jciId": 11683,
                        "entityField": "caiTelnumber",
                        "chineseField": "电话",
                        "showField": "电话",
                        "isShow": 1,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 4,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    // {
                    // "jcfId": 5604,
                    // "jciId": 11683,
                    // "entityField": "caiArea",
                    // "chineseField": "区",
                    // "showField": "区",
                    // "isShow": 1,
                    // "isRequired": 0,
                    // "isChange": 1,
                    // "fieldType": "string",
                    // "formatterContent": null,
                    // "searchId": null,
                    // "extractId": null,
                    // "isReserved": 0,
                    // "sort": 4,
                    // "fieldWeight": 100,
                    // "isRift": 0,
                    // "riftField": null
                    // },
                    {
                        "jcfId": 5606,
                        "jciId": 11683,
                        "entityField": "caiPostcode",
                        "chineseField": "邮编",
                        "showField": "邮编",
                        "isShow": 1,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 5,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5608,
                        "jciId": 11683,
                        "entityField": "caiLinker",
                        "chineseField": "联系人",
                        "showField": "联系人",
                        "isShow": 1,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 5,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5608,
                        "jciId": 11683,
                        "entityField": "remark",
                        "chineseField": "备注",
                        "showField": "备注",
                        "isShow": 1,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 5,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5599,
                        "jciId": 11683,
                        "entityField": "caiState",
                        "chineseField": "状态",
                        "showField": "状态",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 6,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5607,
                        "jciId": 11683,
                        "entityField": "caiReserves1",
                        "chineseField": "预留字段",
                        "showField": "预留字段",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 1,
                        "sort": 7,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5609,
                        "jciId": 11683,
                        "entityField": "caiReserves2",
                        "chineseField": "预留字段",
                        "showField": "预留字段",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 1,
                        "sort": 8,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5610,
                        "jciId": 11683,
                        "entityField": "caiReserves3",
                        "chineseField": "预留字段",
                        "showField": "预留字段",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 1,
                        "sort": 9,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5611,
                        "jciId": 11683,
                        "entityField": "caiReserves4",
                        "chineseField": "预留字段",
                        "showField": "预留字段",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 1,
                        "sort": 10,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5612,
                        "jciId": 11683,
                        "entityField": "caiReserves5",
                        "chineseField": "预留字段",
                        "showField": "预留字段",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 1,
                        "sort": 11,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5613,
                        "jciId": 11683,
                        "entityField": "caiReserves6",
                        "chineseField": "预留字段",
                        "showField": "预留字段",
                        "isShow": 0,
                        "isRequired": 0,
                        "isChange": 1,
                        "fieldType": "string",
                        "formatterContent": null,
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 1,
                        "sort": 12,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    },
                    {
                        "jcfId": 5616,
                        "jciId": 11683,
                        "entityField": "isDefault",
                        "chineseField": "是否为默认地址",
                        "showField": "是否为默认地址",
                        "isShow": 1,
                        "isRequired": 1,
                        "isChange": 1,
                        "fieldType": "formatter",
                        "formatterContent": "[{\"key\":0,\"value\":\"否\"},{\"key\":1,\"value\":\"是\"}]",
                        "searchId": null,
                        "extractId": null,
                        "isReserved": 0,
                        "sort": 18,
                        "fieldWeight": 100,
                        "isRift": 0,
                        "riftField": null
                    }
                ]
            },

            countryList: [],
            pageType: ''

        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 新增或修改
        async sendDataAction(formName) {
            let flag = false
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (!sendData.areaCode) {
                sendData.caiProvince = ''
                sendData.caiCity = ''
                sendData.caiArea = ''
            }
            if (this.pageType == 'sales') {
                let responseData = await this.$http.cusmasterAddressMaintain(sendData);
                if (responseData.status == 200) {
                    this.dataActionBox.showStatus = false
                    this.$message({
                        message: '新增成功',
                        type: "success",
                    });
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
                return
            }
            this.$emit('returnAddress', sendData, this.dataActionBox.actionType)
            this.dataActionBox.showStatus = false
            this.$refs['sendDataInfo'].resetFields()
            this.init()
        },

        isShowData(name, value) {
            this.sendDataInfo[name] = value
        },
        //取消
        initActionBox() {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dataActionBox.showStatus = false
                    this.$refs['sendDataInfo'].resetFields()
                    this.init()
                })
                .catch(() => { })
        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }
            this.sendDataInfo.caiState = 0
            this.dataActionBox.actionType = 0
        },
        //父级传入
        openBox(cate, mainId, oldData = '', type) {
            this.pageType = type
            this.formData.jurconfigform.forEach(v => { if (v.entityField == 'isDefault') v.isShow = 0 })
            this.init()
            this.sendDataInfo.cmId = mainId
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增地址信息'
                this.dataActionBox.openMode = 'ltr'
            } else {
                this.dataActionBox.boxTitle = '编辑地址信息'
                this.dataActionBox.openMode = 'rtl'
                for (let key in this.sendDataInfo) {
                    this.sendDataInfo[key] = oldData[key]
                }
            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true

        },


        // 获取国家
        async getCountry() {
            let responseData = await this.$http.getPartDictionariesData({ ids: [26] })
            if (responseData.status == 200) {
                if (responseData.result.gj) {
                    this.countryList = responseData.result.gj
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



        handleChange() {
            setTimeout(() => {
                var node = this.$refs['cascader'].getCheckedNodes()[0]
                if (!node) {
                    this.sendDataInfo.caiProvince = ""
                    this.sendDataInfo.caiCity = ""
                    this.sendDataInfo.caiArea = ""
                    return
                }
                if (node.pathLabels.length == 3) {
                    this.sendDataInfo.caiProvince = node.pathLabels[0]
                    this.sendDataInfo.caiCity = node.pathLabels[1]
                    this.sendDataInfo.caiArea = node.pathLabels[2]
                } else if (node.pathLabels.length == 2) {
                    this.sendDataInfo.caiProvince = node.pathLabels[0]
                    this.sendDataInfo.caiCity = node.pathLabels[1]
                    this.sendDataInfo.caiArea = ""
                }
            }, 100)
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getCountry()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style></style>